module.exports = __webpack_public_path__ + "img/add-order-b.91d17962.svg";